import { Box, Typography } from "@mui/material";
import { memo, useCallback, useState } from "react";
import { IFiltersListProps } from "./models";
import { FilterItem } from "./FilterItem/FilterItem";
import { IDashboardFilters } from "../../../../../../models/dashboard";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "components.panel.";

export const FiltersList = memo(
  ({ filters, filtersList, onChangeFiltersHandler }: IFiltersListProps) => {
    const { t } = useTranslation();

    const getKeyHandler = useCallback((code: string) => {
      switch (code) {
        case "1":
          return "ticketServices";
        case "2":
          return "ticketWorkspaces";
        case "3":
          return "ticketChannels";
        case "4":
          return "ticketCustomerServiceTypes";
        case "5":
          return "ticketTypes";
      }
    }, []);

    return (
      <Box sx={{ my: 2, display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          sx={(t) => ({
            pb: 1,
            fontSize: 18,
          })}
        >
          {t(`${TRANSLATION_PATH}filters`)}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {filters
            .sort((a, b) =>
              a.code! < b.code! ? -1 : a.code! > b.code! ? 1 : 0
            )
            .map((filter) => (
              <FilterItem
                value={
                  filtersList[
                    getKeyHandler(filter.code!) as keyof IDashboardFilters
                  ]
                }
                keyValue={getKeyHandler(filter.code!)!}
                data={filter}
                onChangeFiltersHandler={onChangeFiltersHandler}
                key={filter.id}
              />
            ))}
        </Box>
      </Box>
    );
  }
);
